import { occupationSchema } from '../../../../backend/config/classifiers/types';
import { getDefaultOccupationData } from '../../../../backend/config/classifiers/utils/getDefaultOccupationData';
import { findOigBoardId, findOigCredentialId, updateLicenseCheckLatestStatusByFilter } from '../../../../backend/features/credentialing-verification';
import { allowManageCredentialingClassifiers } from '../../../../backend/features/permissions';
import { updatePersonCredentialsByFilter } from '../../../../backend/features/person-credentials';
import { featureEnabled } from '../../../../backend/utils';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const occupationEntityName = 'occupation';
const occupationColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { groupId: {
        type: 'id',
        index: true,
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineOccupationClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 5,
            columns: occupationColumns,
            onMigrate: (params) => params.oldData,
            onTransform: (context, params) => {
                const credentialEnabled = featureEnabled(context, 'credential');
                if (params.action === 'create' && credentialEnabled) {
                    params.data.credentials = addOigCredential(context.appState, params.data.credentials);
                }
                return {
                    data: params.data,
                    columns: Object.assign(Object.assign({}, transformClassifierColumns(params)), { groupId: params.data.groupId, search: [params.data.name, params.data.status].join(' ') }),
                };
            },
            onChangeSync: (context) => {
                context.invalidateAppState('occupations');
            },
            onScheduleChangedAsync: (context) => {
                if (featureEnabled(context, 'credential')) {
                    return true;
                }
                return false;
            },
            onChangedAsync: (context, params) => {
                if (params.action === 'update') {
                    const updatePersonCredentials = JSON.stringify(params.prevData) !== JSON.stringify(params.data);
                    const updateLatestStatus = params.prevData.name !== params.data.name;
                    if (updatePersonCredentials || updateLatestStatus) {
                        if (updatePersonCredentials) {
                            updatePersonCredentialsByFilter(context, {
                                column: 'occupationIds',
                                op: 'contains',
                                value: [params.id],
                            });
                        }
                        if (updateLatestStatus) {
                            updateLicenseCheckLatestStatusByFilter(context, {
                                column: 'occupationId',
                                op: '=',
                                value: params.id,
                            });
                        }
                    }
                }
            },
            onAnonymousAuthGet: (appState, response) => response,
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: (context) => getDefaultOccupationData(context),
        defaultNameChanges: [
            {
                from: 'Marriage & Family Therapist (MFT)',
                to: 'Marriage and Family Therapist',
            },
        ],
        publicData: [
            {
                mapValue: (row) => ({ value: row.id, label: row.columns.name, groupId: row.columns.groupId }),
            },
        ],
    }, occupationSchema);
}
export function addOigCredential(appStateCredentialing, dataCredentials) {
    const credentials = dataCredentials !== null && dataCredentials !== void 0 ? dataCredentials : [];
    const oigCredentialId = findOigCredentialId(appStateCredentialing.occupationCredentials);
    const oigBoardId = findOigBoardId(appStateCredentialing.jasBoards);
    const occupationHasOigCredential = dataCredentials === null || dataCredentials === void 0 ? void 0 : dataCredentials.some((occupationCredential) => occupationCredential.credentialId === oigCredentialId);
    if (oigCredentialId && oigBoardId && !occupationHasOigCredential) {
        credentials.push({
            credentialId: oigCredentialId,
            jasBoardId: oigBoardId,
            ecl1: true,
            ecl2: true,
            ecl3: true,
            ecl4: true,
        });
    }
    return credentials;
}
